export enum DiamondBaseColor {
  orange,
  green,
  red,
  blue,
}

export enum DiamondBasePosition {
  up,
  middle,
  down,
}
